export enum UploadAttachmentTypeEnum {
  EventCoverPhoto = 'uploaded_eventCoverPhoto',
  ItemPhoto = 'uploaded_itemPhoto',
  ItemCertificate = 'uploaded_itemCertificate',
  ItemSignature = 'uploaded_itemSignature',
  CollectionPhoto = 'uploaded_collectionPhoto',
  PublicProfileCoverPhoto = 'uploaded_publicProfileCoverPhoto',
  PublicProfileGalleryPhoto = 'uploaded_publicProfileGalleryPhoto',
  PublicProfileAvatar = 'uploaded_publicProfileAvatar',
  SliderPhoto = 'uploaded_sliderPhoto'
}
